<template>
  <div>
    <div class="step" v-loading="data.length < 1">
      <div class="child" :style="`width:${100 / data.length}%;color:${active == index ? '#409eff' : active < index ? 'rgb(200, 200, 200)' : '#67c23a'}`" v-for="(item, index) in data" :key="index">
        <div class="line" v-if="index + 1 != data.length" :style="`background:${active <= index ? '#c0c4cc' : '#67c23a'}`"></div>
        <div class="icon"><i class="el-icon-s-custom"></i></div>
        <div class="text">审批节点：{{ item.displayName }}</div>
        <div class="underline"></div>
        <div v-if="item.operatorName" class="text">{{ (index == 0 ? '发起人：' : '审批人：') + item.operatorName }}</div>
        <div v-if="item.operatorName" class="underline"></div>
        <div v-if="item.finishTime" class="text">{{ (index == 0 ? '发起时间：' : '审批时间：') + item.finishTime }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'checkFlow',
  props: ['data'],
  data() {
    return {
      active: 0
    };
  },
  watch: {
    data: {
      handler(v) {
        this.setactive(v);
      },
      // 初始化执行一次
      immediate: true
    }
  },
  created() {},
  beforeMount() {},
  mounted() {},
  computed: {},
  methods: {
    setactive(v) {
      try {
        v.forEach((va, i) => {
          if (va.currentNode) {
            this.active = i;
          }
        });
        // 判断是否通过
        if (v.every(va => !va.currentNode)) {
          this.active = 9999;
        }
      } catch (error) {
        this.$message.error('数据为空');
      }
    }
  }
};
</script>
<style lang="less">
.step {
  // border: 1px solid red;
  height: 300px;
  font-size: 14px;
  color: #409eff;
  .child {
    float: left;
    width: 45%;
    text-align: center;
    margin: 30px 0 0;
    padding: 20px 10px;
    // border: 1px solid rgb(2, 0, 117);
    position: relative;
    .line {
      width: 80%;
      height: 3px;
      // background: #c0c4cc;
      border-radius: 20px;
      position: absolute;
      top: 45px;
      left: 60%;
    }
    .icon {
      font-size: 45px;
    }
    .underline {
      width: 160px;
      margin: 5px auto;
      border-bottom: 1px solid rgb(230, 230, 230);
    }
  }
}
</style>